import * as React from 'react';

export type EditQuestionsContextType = {
  editQuestionIdx: number | null;
  editQuestionValue: string;
  onEditQuestion: (idx: number | null, value?: string) => void;
};

export const EditQuestionsContext =
  React.createContext<EditQuestionsContextType>({
    editQuestionIdx: null,
    editQuestionValue: '',
    onEditQuestion: () => {},
  });

export const useEditQuestions = () => {
  return React.useContext(EditQuestionsContext);
};

export const useEditQuestionsContextValue = () => {
  const [editQuestionIdx, setEditQuestionIdx] = React.useState<number | null>(
    null
  );
  const [editQuestionValue, setEditQuestionValue] = React.useState('');

  const onEditQuestion = React.useCallback(
    (idx: number | null, value = '') => {
      setEditQuestionIdx(idx);
      setEditQuestionValue(value);
    },
    [setEditQuestionIdx, setEditQuestionValue]
  );

  return {
    editQuestionIdx,
    editQuestionValue,
    onEditQuestion,
  };
};
